import React from "react";
import { useAuth } from "../../contexts/authContext";
import { useNavigate, Link } from 'react-router'

import { app } from '../../firebase/firebase';
import { getPremiumStatus } from "../stripe/subscriptionStatus.ts";
import { useEffect, useState } from "react";
import { auth } from "../../firebase/firebase";

export const SubscriptionGaurd = ({ component: C }) => {
  const { userLoggedIn } = useAuth();

  const navigate = useNavigate()
  const [page, setPage] = useState(<div className="page-layout"></div>);

  useEffect(() => {
    getPremiumStatus(app).then(e => {
      if (e) {
        setPage(<C />);
      } else {
        navigate('/subscribe')
      }
    });

  }, [app, auth.currentUser?.uid]);
  return (
    <>
      {page}
    </>
  )
};